module.exports = __webpack_public_path__ + "img/1905b3c.jpg";